module.exports = __webpack_public_path__ + "static/media/mobile-abattoir-cover.74634da0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Themes/Abattoir/mobile-abattoir-cover.jpg
// module id = 587
// module chunks = 0